import React, { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import ForgotPasswordModal from './ForgotPasswordModal';

const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.lightBlue};
  text-decoration: underline;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  
  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
`;

const ForgotPasswordLink: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { userRole } = useParams();

  const handleForgotPassword = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <StyledLink onClick={handleForgotPassword}>
        Forgot Password?
      </StyledLink>
      
      <ForgotPasswordModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        defaultUserType={userRole || 'student'}
      />
    </>
  );
};

export default ForgotPasswordLink;
